/**
 * Форматтер преводит значение к виду цены,
 * например 1000000 к 1 000 000
 * @param value
 */
export var priceFormatter = function priceFormatter(value) {
  var price = value.toString();
  return price.replace(/\d(?=(?:\d{3})+$)/g, function (match) {
    return "".concat(match, " ");
  });
};